import {
  RESET_ACTIVITY_DATA,
  RESET_CURRENT_ACTIVITY_STATE,
  SET_ACTIVITY_STATUS,
  SET_AUDIO_PLAYED,
  SET_BOOK_STRUCTURE,
  SET_CURRENT_ACTIVITY_STATE,
  SET_CURRENT_ACTIVITY_STUDENT_ATTEMPTS_DATA,
  SET_CURRENT_ACTIVITY,
  SET_CURRENT_MAUTHOR,
  SET_CURRENT_PAGE_MAUTHOR,
  SET_CURRENT_SECTION,
  SET_CURRENT_UNIT,
  SET_CURRENT_USER_BOOK_INFO,
  SET_HIGHLIGHTS,
  SET_OUTDATED_HIGHLIGHTS,
  SET_THIRD_PARTY_VISITED_LINKS,
  SET_USER_FLAGS,
  SET_HIGHLIGHTS_ERROR,
  SET_SEARCH,
  SET_SNACKBAR_NAVV2,
  SET_USER_ACCESSIBILITY_SETTINGS,
  SET_LINKS,
  SET_INDEX_OPEN_BLACKLIST,
  SET_SIDE_BAR_OPEN,
  SET_SECTION_FEEDBACKS,
  SET_ATTEMPT_MODAL_DATA,
  SET_SIDE_BAR_SELECTED_TAB,
  SET_IS_SEARCH_CONTENT_OPEN,
  SET_IS_OPEN_DOT_MENU,
  SET_SECTION_CONTENT_RESTRICTION_POLICIES,
  SET_CHAT_IA_OPEN_REQUEST,
} from '../actions/NavV2Actions'

function initialState() {
  return {
    activeSections: [],
    activity: undefined,
    activityState: undefined,
    attemptModalData: undefined,
    audioPlayed: [],
    bookStructure: undefined,
    chatIAOpenRequest: null,
    contentRestrictionPoliciesBySectionId: {},
    currentPageMauthor: undefined,
    highlights: undefined,
    highlightsError: false,
    indexOpenBlacklist: [],
    isOpenDotMenu: false,
    isSearchContentOpen: false,
    isTextReaderOpen: false,
    links: {
      ownLinks: undefined,
      teacherLinks: undefined,
      thirdPartyLinks: undefined,
    },
    mauthor: undefined,
    outdatedHighlights: undefined,
    search: {
      error: null,
      isLoading: false,
      query: '',
      results: null,
    },
    sectionFeedbacks: [],
    sideBarSelectedTab: '',
    snackbar: {},
    studentAttemptsData: undefined,
    thirdPartyVisitedLinks: [],
    unit: undefined,
    userAccessibilitySettings: undefined,
    userBookInfo: undefined,
  }
}

export default function navV2Reducer(state = initialState(), action) {
  switch (action.type) {
    case SET_CURRENT_UNIT:
      return {
        ...state,
        audioPlayed: initialState().audioPlayed,
        contentRestrictionPoliciesBySectionId: initialState().contentRestrictionPoliciesBySectionId,
        highlights: initialState().highlights,
        links: initialState().links,
        thirdPartyVisitedLinks: initialState().thirdPartyVisitedLinks,
        unit: action.payload,
      }

    case SET_SECTION_CONTENT_RESTRICTION_POLICIES:
      return {
        ...state,
        contentRestrictionPoliciesBySectionId: action.payload || {},
      }
    case SET_CURRENT_SECTION:
      return { ...state, activeSections: action.payload }
    case SET_CURRENT_ACTIVITY:
      return { ...state, activity: action.payload }
    case SET_CURRENT_ACTIVITY_STUDENT_ATTEMPTS_DATA:
      return {
        ...state,
        studentAttemptsData: action.payload,
      }
    case SET_CURRENT_ACTIVITY_STATE:
      return {
        ...state,
        activityState: {
          ...state.activityState,
          ...action.payload,
        },
      }
    case SET_CURRENT_MAUTHOR:
      return { ...state, mauthor: action.payload }
    case SET_CURRENT_PAGE_MAUTHOR:
      return { ...state, currentPageMauthor: action.payload }
    case RESET_ACTIVITY_DATA:
      return {
        ...state,
        activity: undefined,
        activityState: undefined,
        studentAttemptsData: undefined,
      }
    case RESET_CURRENT_ACTIVITY_STATE:
      return {
        ...state,
        activityState: undefined,
      }
    case SET_BOOK_STRUCTURE:
      return { ...state, bookStructure: action.payload }
    case SET_HIGHLIGHTS:
      return { ...state, highlights: action.payload, highlightsError: false }
    case SET_OUTDATED_HIGHLIGHTS:
      return { ...state, outdatedHighlights: action.payload }
    case SET_HIGHLIGHTS_ERROR:
      return { ...state, highlightsError: action.payload }
    case SET_USER_FLAGS:
      return { ...state, userFlags: action.payload }
    case SET_CHAT_IA_OPEN_REQUEST:
      return { ...state, chatIAOpenRequest: action.payload }
    case SET_CURRENT_USER_BOOK_INFO:
      return {
        ...state,
        userBookInfo: {
          book: action.payload.book,
          legacy: action.payload.legacy,
          user: action.payload.user,
          userBook: action.payload.userBook,
        },
      }
    case SET_USER_ACCESSIBILITY_SETTINGS:
      return {
        ...state,
        userAccessibilitySettings: action.payload,
      }

    case SET_THIRD_PARTY_VISITED_LINKS:
      return {
        ...state,
        thirdPartyVisitedLinks: action.payload,
      }

    case SET_ACTIVITY_STATUS:
      return {
        ...state,
        activityStatus: action.payload,
      }

    case SET_AUDIO_PLAYED:
      return {
        ...state,
        audioPlayed: action.payload,
      }

    case SET_SEARCH:
      return {
        ...state,
        search: {
          ...state.search,
          ...action.payload,
        },
      }

    case SET_SNACKBAR_NAVV2:
      return {
        ...state,
        snackbar: action.payload,
      }

    case SET_LINKS:
      return {
        ...state,
        links: {
          ...state.links,
          ...action.payload,
        },
      }

    case SET_INDEX_OPEN_BLACKLIST:
      return {
        ...state,
        indexOpenBlacklist: action.payload,
      }
    case SET_SIDE_BAR_OPEN:
      return {
        ...state,
        isSideBarOpen: action.payload,
      }

    case SET_SECTION_FEEDBACKS:
      return {
        ...state,
        sectionFeedbacks: action.payload,
      }

    case SET_ATTEMPT_MODAL_DATA:
      return {
        ...state,
        attemptModalData: action.payload,
      }

    case SET_SIDE_BAR_SELECTED_TAB:
      return {
        ...state,
        sideBarSelectedTab: action.payload,
      }

    case SET_IS_SEARCH_CONTENT_OPEN:
      return {
        ...state,
        isSearchContentOpen: action.payload,
      }

    case SET_IS_OPEN_DOT_MENU:
      return {
        ...state,
        isOpenDotMenu: action.payload,
      }

    default:
      return state
  }
}
